import React, { useEffect, useMemo, useState } from "react";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import ExcelExportModal from "../../../components/ExcelExport/ExcelExportModal";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useExportBorosilOrderListMutation, useFetchBorosilOrderListCountMutation, useFetchBorosilOrderListMutation } from "../../../features/tenant/Borosil/SalesBoosterHistoryBorosilApi";


const BorosilOrderList = () => {
    const zoneId = getLoginUserData().zone_id;
    const [
        fetchBorosilOrderList,
        {
            data: pointsScanHistoryData,
            error: pointsScanHistoryError,
            isLoading: pointsScanHistoryIsLoading,
        },
    ] = useFetchBorosilOrderListMutation();
    const [
        countBorosilOrderList,
        {
            data: countpointsScanHistoryData,
            error: countpointsScanHistoryError,
            isLoading: countpointsScanHistoryIsLoading,
        },
    ] = useFetchBorosilOrderListCountMutation();

    const [
        exportBorosilOrderList,
        { isLoading: isExporting },
    ] = useExportBorosilOrderListMutation();

    const [showExportModal, setShowExportModal] = useState(false);

    const [myList, setMyList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);
    const currentDate = new Date().toISOString().split("T")[0];

    const initialRequest = {
        limit: 10,
        offset: 0,
        start_date: "",
        end_date: "",
        voucher_no: "",
        dlrCode: "",
        name: "",
        mobile: ""
    };


    const [request, setRequest] = useState(initialRequest);

    const clearFilters = () => {
        setRequest(initialRequest);
    };

    useEffect(() => {
        if (
            request.start_date === "" &&
            request.end_date === "" &&
            request.voucher_no === ""
        ) {
            fetchBorosilOrderListFunction();
        }
    }, [request]);

    useEffect(() => {
        if (
            request.start_date === "" &&
            request.end_date === "" &&
            request.voucher_no === ""
        ) {
            countBorosilOrderListCountFunction();
        }
    }, [request]);

    useEffect(() => {
        if (limit != 10 || offset != 0) fetchBorosilOrderListFunction();
    }, [limit, offset]);

    const fetchBorosilOrderListFunction = () => {
        fetchBorosilOrderList({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: request,
        });
    };

    const countBorosilOrderListCountFunction = () => {
        const modifiedRequest = { ...request };
        modifiedRequest.limit = null;
        modifiedRequest.offset = null;
        countBorosilOrderList({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: request,
        });
    };


    useEffect(() => {
        if (pointsScanHistoryData && pointsScanHistoryData?.body) {
            console.log("success scan history", pointsScanHistoryData);
            setMyList(
                pointsScanHistoryData.body && pointsScanHistoryData.body.data
                    ? pointsScanHistoryData.body.data
                    : []
            );
            if (countpointsScanHistoryData && countpointsScanHistoryData.body) {
                setTotalRows(
                    countpointsScanHistoryData.body &&
                        countpointsScanHistoryData.body.total
                        ? countpointsScanHistoryData.body.total
                        : 0
                );
            }
        }
        if (countpointsScanHistoryData && countpointsScanHistoryData.body) {
            setTotalRows(
                countpointsScanHistoryData.body && countpointsScanHistoryData.body.total
                    ? countpointsScanHistoryData.body.total
                    : 0
            );
        }
    }, [
        pointsScanHistoryData,
        pointsScanHistoryError,
        countpointsScanHistoryData,
    ]);

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };
    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },

        {
            name: "Name",
            cell: (row) => row.name,
            sortable: true,
            width: "120px",
        },

        {
            name: "Phone",
            cell: (row) => row.mobile,
            sortable: true,
            width: "120px",
        },
        {
            name: "Party Code",
            cell: (row) => row.party_code,
            sortable: true,
            width: "120px",
        },
        {
            name: "Distributor Code",
            cell: (row) => row.distributor_code,
            sortable: true,
            width: "120px",
        },
        {
            name: "User ID",
            cell: (row) => row.user_id,
            sortable: true,
            width: "120px",
        },
        {
            name: "Voucher Date",
            cell: (row) => new Date(row.voucher_date).toLocaleDateString(),
            sortable: true,
            width: "150px",
        },
        {
            name: "Voucher No ",
            cell: (row) => row.voucher_no,
            sortable: true,
            width: "120px",
        },
        {
            name: "Points",
            cell: (row) => row.points,
            sortable: true,
            width: "120px",
        },
        {
            name: "Purchase Amount",
            cell: (row) => row.purchase_amount,
            sortable: true,
        },
        {
            name: "Total SKU",
            cell: (row) => row.total_sku,
            sortable: true,
            width: "120px",
        },
        {
            name: "Qty",
            cell: (row) => row.qty,
            sortable: true,
        },
        {
            name: "Month",
            cell: (row) => row.month,
            sortable: true,
        },
        {
            name: "Year",
            cell: (row) => row.year,
            sortable: true,
        },
        {
            name: "Financial Year",
            cell: (row) => row.financial_year,
            sortable: true,
        },

        {
            name: "Created At",
            cell: (row) => new Date(row.created_at).toLocaleString(),
            width: "120px",
            sortable: true,
        },
    ];

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Order List
                        <LinksComponent />
                    </div>

                    <div className="p-3">
                        {/* {pointsScanHistoryCsvData && pointsScanHistoryCsvData.body.data && (
              <ExportCSV
                data={
                  pointsScanHistoryCsvData && pointsScanHistoryCsvData.body.data
                }
                columnsToExport={[
                  "name",
                  "mobile",
                  "user_type",
                  "points",
                  "product_name",
                  "product_code",
                  "qr_id",
                  "batch_running_code",
                  "method",
                ]}
              />
            )} */}
                        <div className="mb-2 flex justify-end">
                            <button
                                className="btn btn-outline-primary"
                                onClick={() => setShowExportModal(true)}
                            >
                                Exports
                            </button>
                        </div>

                        {showExportModal && (
                            <ExcelExportModal
                                show={showExportModal}
                                setShow={setShowExportModal}
                                columns={columns}
                                request={request}
                                exportFunc={exportBorosilOrderList}
                                isLoading={isExporting}
                                title="Export Borosil Order List"
                                filename="BorosilOrderList"
                                showFilters={true}
                                filterConfig={[
                                    { label: "Name", key: "name", type: "text" },
                                    { label: "Mobile", key: "mobile", type: "text" },
                                    { label: "User ID", key: "dlrCode", type: "text" },
                                    { label: "Voucher No", key: "voucher_no", type: "text" },
                                    { label: "Voucher Start Date", key: "start_date", type: "date" },
                                    { label: "Voucher End Date", key: "end_date", type: "date" },
                                ]}
                            />
                        )}

                        <div className=" w-full bg-white shadow rounded-lg">
                            <div className="border-b  border-gray-300 bg-gray-100 rounded-t-lg p-3">
                                <div className="flex  space-x-2 justify-between">
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Name
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Name..."
                                                required
                                                value={request.name}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => {
                                                        return { ...prevState, name: newValue };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Mobile
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Mobile ..."
                                                required
                                                value={request.mobile}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => {
                                                        return { ...prevState, mobile: newValue };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                User ID
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="User ID ..."
                                                required
                                                value={request.dlrCode}
                                                onChange={(e) => {
                                                    const newValue = e.target.value.trim();
                                                    setRequest((prevState) => {
                                                        return { ...prevState, dlrCode: newValue };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Voucher No
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Voucher No ..."
                                                required
                                                value={request.voucher_no}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => {
                                                        return { ...prevState, voucher_no: newValue };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 h-10 ">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Voucher Start Date
                                            </label>
                                            <input
                                                type="date"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="Start Date"
                                                value={request.start_date}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            start_date: newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="w-52 h-10 ">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Voucher End Date
                                            </label>
                                            <input
                                                type="date"
                                                id="default-search"
                                                className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                placeholder="End Date"
                                                value={request.end_date}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            end_date: newValue,
                                                        };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex flex-row w-52 gap-2 h-10">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right  p-2"
                                                onClick={() => {
                                                    fetchBorosilOrderListFunction();
                                                    countBorosilOrderListCountFunction();
                                                    // fetchCsvPointsScanHistoryFunction();
                                                }}
                                            >
                                                Search
                                            </button>
                                        </div>
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                &nbsp;
                                            </label>
                                            <button
                                                className="btn btn-outline-primary clear-both float-right  whitespace-nowrap p-2"
                                                onClick={() => {
                                                    clearFilters();
                                                }}
                                            >
                                                Clear Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                {pointsScanHistoryIsLoading && <CircleLoaderComponent />}
                                <DataTableComponent
                                    keyField={(row) => row.SNo}
                                    columns={columns}
                                    // title={""}
                                    data={myList}
                                    // loading={loading}
                                    totalRows={totalRows}
                                    handlePerRowsChange={handlePerRowsChange}
                                    handlePageChange={handlePageChange}
                                    paginationDefaultPage={currentPage}
                                    paginationResetDefaultPage={paginationResetToggle}
                                >
                                    <div className="flex m-2 space-x-2 justify-end"></div>
                                </DataTableComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BorosilOrderList;
